<template>
    <TxRendererScreenshotArea>
        <YouAndMeText/>
        <YouAndMeTextTitle/>
    </TxRendererScreenshotArea>
</template>

<script>
    import YouAndMeText from './YouAndMeText'
    import YouAndMeTextTitle from './YouAndMeTextTitle'
    import YouAndMeTextModule from "../store-mixin";

    export default {
        name: 'YouAndMeTextProduct',
        mixins: [YouAndMeTextModule()],
        components: {
            YouAndMeText,
            YouAndMeTextTitle,
        },
    }
</script>

<style scoped lang="scss">

</style>

